import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { BatchProductDetail, ProductDetailsModal } from "./type";

const initialState: ProductDetailsModal = {
  productDetails: {
    _id: "",
    batchId: "",
    product: { type: "", subType: "", image: "" },
    manufacturerId: "",
    label: "",
    strain: {
      mongoId: "",
      name: "",
      strainId: "",
      lineage: [],
      strainType: "",
    },
    batchTokenId: "",
    coaTokenizedAt: "",
    growerNote: "",
    manufacturerName: "",
    sampleImage: "",
    coaPdfIpfsHash: "",
    sampleStatus: "",
    testedDate: "",
    coaNftViewUrl: "",
    blockchainTransaction: "",
    viewProductOnChainUrl: "",
    thcTotal: "",
    cbdTotal: "",
    climsId: "",
    tarpeneTotal: "",
    cannabinoidTotal: "",
    topThreeTerpenes: [],
    topThreeCannabinoids: [],
    manufacturerCompanyPicture: "",
    ratingReviews: [],
    consumerClaimId: "",
    isRatingReview: false,
    averageRating: 0,
    totalRating: 0,
    totalRatingPerson: 0,
    dataPlatform: "",
    maxThcMg: "",
    maxCbdMg: "",
    maxThcWeight: "",
    maxCbdWeight: "",
    totalTerpenesMg: "",
    totalCannabinoidsMg: "",
    totalCannabinoidsWeight: "",
    totalTerpenesPercentWeight: "",
    scanCount: "",
    isOtherBatchReviewAvailable: false,
  },
};

const ProductDetailsSlice = createSlice({
  name: "product-details",
  initialState,
  reducers: {
    setBatchProductDetails: (
      state: ProductDetailsModal,
      action: PayloadAction<BatchProductDetail>,
    ) => {
      state.productDetails = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBatchProductDetails } = ProductDetailsSlice.actions;

export default ProductDetailsSlice.reducer;
